define('utils/colors',{
    sensiToRGB: function(value, minDb, maxDb) {
        if (value == minDb - 1) {
            return 'rgb(192,192,192)';
        }
        var quarter = (maxDb - minDb + 1) / 4;
        var loc = 0;
        if (value < (quarter + minDb)) {
            loc = 255 * (value - minDb) / quarter;
            return 'rgb(0, ' + Math.round(loc) + ', 255)';
        } else if (value < (2 * quarter) + minDb) {
            loc = 255 * (value - minDb - quarter) / quarter;
            return 'rgb(0, 255, ' + Math.round(255 - loc) + ')';
        } else if (value < (3 * quarter) + minDb) {
            loc = 255 * (value - minDb - (2 * quarter)) / quarter;
            return 'rgb(' + Math.round(loc) + ', 255, 0)';
        } else {
            loc = 255 * (value - minDb - (3 * quarter)) / quarter;
            return 'rgb(255, ' + Math.round((255 - loc)) + ', 0)';
        }
    },
    RGBToHSB: function(r, g, b) {
        var cmax = (r > g) ? r : g;
        if (b > cmax) {
            cmax = b;
        }
        var cmin = (r < g) ? r : g;
        if (b < cmin) {
            cmin = b;
        }
        var hue, saturation, brightness;
        brightness = cmax / 255;
        if (cmax !== 0) {
            saturation = (cmax - cmin) / cmax;
        } else {
            saturation = 0;
        }
        if (saturation === 0) {
            hue = 0;
        } else {
            var redc = (cmax - r) / (cmax - cmin);
            var greenc = (cmax - g) / (cmax - cmin);
            var bluec = (cmax - b) / (cmax - cmin);
            if (r == cmax) {
                hue = bluec - greenc;
            } else if (g == cmax) {
                hue = 2 + redc - bluec;
            } else {
                hue = 4 + greenc - redc;
            }
            hue = hue / 6;
            if (hue < 0) {
                hue = hue + 1;
            }
        }
        return {
            h: hue,
            s: saturation,
            b: brightness
        };
    },
    HSBToRGB: function(hue, saturation, brightness) {
        var r = 0, g = 0, b = 0;
        if (saturation === 0) {
            r = g = b = Math.round(brightness * 255 + 0.5);
        } else {
            var h = (hue - Math.floor(hue)) * 6;
            var f = h - Math.floor(h);
            var p = brightness * (1 - saturation);
            var q = brightness * (1 - saturation * f);
            var t = brightness * (1 - (saturation * (1 - f)));
            switch (Math.floor(h)) {
                case 0:
                    r = brightness * 255 + 0.5;
                    g = t * 255 + 0.5;
                    b = p * 255 + 0.5;
                    break;
                case 1:
                    r = q * 255 + 0.5;
                    g = brightness * 255 + 0.5;
                    b = p * 255 + 0.5;
                    break;
                case 2:
                    r = p * 255 + 0.5;
                    g = brightness * 255 + 0.5;
                    b = t * 255 + 0.5;
                    break;
                case 3:
                    r = p * 255 + 0.5;
                    g = q * 255 + 0.5;
                    b = brightness * 255 + 0.5;
                    break;
                case 4:
                    r = t * 255 + 0.5;
                    g = p * 255 + 0.5;
                    b = brightness * 255 + 0.5;
                    break;
                case 5:
                    r = brightness * 255 + 0.5;
                    g = p * 255 + 0.5;
                    b = q * 255 + 0.5;
                    break;
            }
        }
        return {
            r: Math.floor(r),
            g: Math.floor(g),
            b: Math.floor(b)
        };
    }
});

